"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.Comp = void 0;
var react_1 = __importStar(require("react"));
var index_styled_1 = require("./index.styled");
var useContainerQuery_1 = require("../../utils/customHooks/useContainerQuery");
var Comp = function (_a, ref //if a ref is passed from outside, it will override the containerQuery feature
) {
    var children = _a.children, className = _a.className, style = _a.style, enableContainerQuery = _a.enableContainerQuery;
    var _b = (0, useContainerQuery_1.useContainerQuery)({
        enabled: enableContainerQuery,
    }), selfRef = _b.ref, containerQuery = _b.containerQuery;
    return (react_1.default.createElement(index_styled_1.StyledContainer, { ref: ref || selfRef, className: className || "", style: style, containerQuery: containerQuery }, children));
};
exports.Comp = Comp;
/**
 * @component Renders a container component with optional container query feature.
 *
 * - The properties of the container component.
 * @prop {React.ReactNode} props.children - The child elements to be rendered within the container.
 * @prop {string} props.className - The CSS class for styling the container.
 * @prop {Object} props.style - The inline styles for the container.
 * @prop {boolean} props.enableContainerQuery - Flag to enable or disable the container query feature.
 * @prop {React.RefObject<HTMLDivElement> | null} ref - Reference object to the container element.
 * @return {React.ReactElement} The rendered container component.
 */
exports.Container = (0, react_1.forwardRef)(exports.Comp);
